import { IEventSchema } from '@faire/web-api--source/indigofair/data/IEventSchema';
import { trackClientEvent } from '@faire/web-api--source/trackClientEvent';
import { ITraceEventMarker } from '@faire/web/common/pete/TraceEventTracker';

export const eventKey =
  'retailer_mobile-footer_desktopgoogle_play_badge_hover-action_unknown';

/**
 * Event when user hovers on play store download badge
 */
export function trackRetailerMobileFooterDesktopgooglePlayBadgeHover(): ITraceEventMarker {
  return trackClientEvent({
    eventKey,
    realTimeTracking: false,
    priority: IEventSchema.Priority.EXTRA_LOW,
  });
}
